import React, { useEffect, useState } from "react";

export default function RotatingWord({ words, interval = 2400, className = "" }) {
  const [idx, setIdx] = useState(0);
  const [hasTicked, setHasTicked] = useState(false);

  useEffect(() => {
    if (!words || words.length < 2) return undefined;
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return undefined;

    const t = setInterval(() => {
      setIdx((i) => (i + 1) % words.length);
      setHasTicked(true);
    }, interval);
    return () => clearInterval(t);
  }, [words, interval]);

  if (!words || words.length === 0) return null;

  const prev = words[(idx - 1 + words.length) % words.length];
  const current = words[idx];

  return (
    <span className={`rotator ${className}`}>
      <span className="rotator-sizer" aria-hidden="true">
        {words.map((w, i) => (
          <span className="rotator-sizer-item" key={i}>{w}</span>
        ))}
      </span>
      {hasTicked && (
        <span className="rotator-word rotator-out" aria-hidden="true" key={`out-${idx}`}>
          {prev}
        </span>
      )}
      <span className="rotator-word rotator-in" key={`in-${idx}`}>
        {current}
      </span>
    </span>
  );
}
